export const TEXT_KEYS = {

    /*** COMMON ***/
    APPLE_STORE: "APPLE_STORE",
    PLAY_STORE: "PLAY_STORE",
    /* NAV_BAR */
    SO_APP: "SO_APP",
    OUR_MISSION: "OUR_MISSION",
    EU_REGULATIONS: "EU_REGULATIONS",
    ABOUT_US: "ABOUT_US",
    SUPPORT_US: "SUPPORT_US",
    CONTACT: "CONTACT",
    EMAIL: "EMAIL",
    SIGN_UP: "SIGN_UP",
    /* SIGN_UP SECTION*/
    SIGN_UP_SECTION_SUBTITLE: "SIGN_UP_SECTION_SUBTITLE",
    SIGN_UP_SECTION_TITLE: "SIGN_UP_SECTION_TITLE",
    /* STORE SECTION */
    STORE_SECTION_TITLE: "STORE_SECTION_TITLE",
    SEND_EMAIL: "SEND_EMAIL",
    SUBMIT: "SUBMIT",

    /*** HOME ***/
    /* HOME - Main Header */
    MAIN_HEADER_TITLE_PART_1: "MAIN_HEADER_TITLE_PART_1",
    MAIN_HEADER_TITLE_PART_2: "MAIN_HEADER_TITLE_PART_2",
    MAIN_HEADER_TITLE_PART_3: "MAIN_HEADER_TITLE_PART_3",
    MAIN_HEADER_SUBTITLE: "MAIN_HEADER_SUBTITLE",
    /* HOME - Module */
    //Module 1 Title
    MODULE_1_TITLE_1: "MODULE_1_TITLE_1",
    MODULE_1_TITLE_2: "MODULE_1_TITLE_2",
    //Module 1 Subtitle
    MODULE_1_SUBTITLE: "MODULE_1_SUBTITLE",
    //Module 2 Title
    MODULE_2_TITLE_1: "MODULE_2_TITLE_1",
    MODULE_2_TITLE_2: "MODULE_2_TITLE_2",
    MODULE_2_TITLE_3: "MODULE_2_TITLE_3",
    MODULE_2_TITLE_4: "MODULE_2_TITLE_4",
    //Module 2 Subtitle
    MODULE_2_SUBTITLE: "MODULE_2_SUBTITLE",
    //Module 3 Title
    MODULE_3_TITLE_1: "MODULE_3_TITLE_1",
    MODULE_3_TITLE_2: "MODULE_3_TITLE_2",
    MODULE_3_TITLE_3: "MODULE_3_TITLE_3",
    MODULE_3_TITLE_4: "MODULE_3_TITLE_4",
    MODULE_3_TITLE_5: "MODULE_3_TITLE_5",
    //Module 2 Subtitle
    MODULE_3_SUBTITLE: "MODULE_3_SUBTITLE",
    //Module 4 Title
    MODULE_4_TITLE_1: "MODULE_4_TITLE_1",
    MODULE_4_TITLE_2: "MODULE_4_TITLE_2",
    MODULE_4_TITLE_3: "MODULE_4_TITLE_3",
    MODULE_4_TITLE_4: "MODULE_4_TITLE_4",
    MODULE_4_TITLE_5: "MODULE_4_TITLE_5",
    //Module 2 Subtitle
    MODULE_4_SUBTITLE: "MODULE_4_SUBTITLE",
    /* HOME - Blue&Cartel */
    //Blue Background
    HOME_BLUE_CARTEL_TITLE: "HOME_BLUE_CARTEL_TITLE",
    HOME_BLUE_CARTEL_SUBTITLE: "HOME_BLUE_CARTEL_SUBTITLE",
    HOME_BLUE_CARTEL_BUTTON: "HOME_BLUE_CARTEL_BUTTON",
    //Cartels
    HOME_BLUE_CARTEL_TITLE_1: "HOME_BLUE_CARTEL_TITLE_1",
    HOME_BLUE_CARTEL_DESCRIPTION_1: "HOME_BLUE_CARTEL_DESCRIPTION_1",
    HOME_BLUE_CARTEL_TITLE_2: "HOME_BLUE_CARTEL_TITLE_2",
    HOME_BLUE_CARTEL_DESCRIPTION_2: "HOME_BLUE_CARTEL_DESCRIPTION_2",
    HOME_BLUE_CARTEL_TITLE_3: "HOME_BLUE_CARTEL_TITLE_3",
    HOME_BLUE_CARTEL_DESCRIPTION_3: "HOME_BLUE_CARTEL_DESCRIPTION_3",
    /* HOME - Mozaic */
    //Header
    HOME_MOZAIC_SUBTITLE: "HOME_MOZAIC_SUBTITLE",
    HOME_MOZAIC_TITLE_1: "HOME_MOZAIC_TITLE_1",
    HOME_MOZAIC_TITLE_2: "HOME_MOZAIC_TITLE_2",
    //Mozaic Text
    HOME_MOZAIC_ITEM_TITLE_1: "HOME_MOZAIC_ITEM_TITLE_1",
    HOME_MOZAIC_ITEM_DESCRIPTION_1: "HOME_MOZAIC_ITEM_DESCRIPTION_1",
    HOME_MOZAIC_ITEM_TITLE_2: "HOME_MOZAIC_ITEM_TITLE_2",
    HOME_MOZAIC_ITEM_DESCRIPTION_2: "HOME_MOZAIC_ITEM_DESCRIPTION_2",
    HOME_MOZAIC_ITEM_TITLE_3: "HOME_MOZAIC_ITEM_TITLE_3",
    HOME_MOZAIC_ITEM_DESCRIPTION_3: "HOME_MOZAIC_ITEM_DESCRIPTION_3",
    HOME_MOZAIC_ITEM_TITLE_4: "HOME_MOZAIC_ITEM_TITLE_4",
    HOME_MOZAIC_ITEM_DESCRIPTION_4: "HOME_MOZAIC_ITEM_DESCRIPTION_4",
    HOME_MOZAIC_ITEM_TITLE_5: "HOME_MOZAIC_ITEM_TITLE_5",
    HOME_MOZAIC_ITEM_DESCRIPTION_5: "HOME_MOZAIC_ITEM_DESCRIPTION_5",
    HOME_MOZAIC_ITEM_TITLE_6: "HOME_MOZAIC_ITEM_TITLE_6",
    HOME_MOZAIC_ITEM_DESCRIPTION_6: "HOME_MOZAIC_ITEM_DESCRIPTION_6",
    HOME_MOZAIC_ITEM_TITLE_7: "HOME_MOZAIC_ITEM_TITLE_7",
    HOME_MOZAIC_ITEM_DESCRIPTION_7: "HOME_MOZAIC_ITEM_DESCRIPTION_7",
    /* HOME - Progress Bar */
    //Progress Bar Title
    HOME_PROGRESS_BAR_SUBTITLE: "HOME_PROGRESS_BAR_SUBTITLE",
    HOME_PROGRESS_BAR_TITLE_1: "HOME_PROGRESS_BAR_TITLE_1",
    HOME_PROGRESS_BAR_TITLE_2: "HOME_PROGRESS_BAR_TITLE_2",
    HOME_PROGRESS_BAR_TITLE_3: "HOME_PROGRESS_BAR_TITLE_3",
    //Progress Bar Body
    HOME_PROGRESS_BAR_CURRENT_STEP: "HOME_PROGRESS_BAR_CURRENT_STEP",
    HOME_PROGRESS_BAR_NEXT_STEP: "HOME_PROGRESS_BAR_NEXT_STEP",
    HOME_PROGRESS_BAR_BUTTON: "HOME_PROGRESS_BAR_BUTTON",

    /*** EU_REGULATION ***/
    /* EU_REGULATION - Main Title */
    EU_REGULATION_MAIN_TITLE_1: "EU_REGULATION_MAIN_TITLE_1",
    EU_REGULATION_MAIN_TITLE_2: "EU_REGULATION_MAIN_TITLE_2",
    EU_REGULATION_MAIN_TITLE_3: "EU_REGULATION_MAIN_TITLE_3",
    EU_REGULATION_MAIN_TITLE_4: "EU_REGULATION_MAIN_TITLE_4",
    /* EU_REGULATION - Section Blue And Cartel */
    //Main Title
    EU_REGULATION_TITLE: "EU_REGULATION_TITLE",
    //Cartel
    EU_REGULATION_CARTEL_TITLE_1: "EU_REGULATION_CARTEL_TITLE_1",
    EU_REGULATION_CARTEL_DESCRIPTION_1: "EU_REGULATION_CARTEL_DESCRIPTION_1",
    EU_REGULATION_CARTEL_TITLE_2: "EU_REGULATION_CARTEL_TITLE_2",
    EU_REGULATION_CARTEL_DESCRIPTION_2: "EU_REGULATION_CARTEL_DESCRIPTION_2",
    EU_REGULATION_CARTEL_TITLE_3: "EU_REGULATION_CARTEL_TITLE_3",
    EU_REGULATION_CARTEL_DESCRIPTION_3: "EU_REGULATION_CARTEL_DESCRIPTION_3",
    /* EU_REGULATION - Section Module */
    EU_REGULATION_SECTION_MODULE_TITLE_1_1: "EU_REGULATION_SECTION_MODULE_TITLE_1_1",
    EU_REGULATION_SECTION_MODULE_TITLE_1_2: "EU_REGULATION_SECTION_MODULE_TITLE_1_2",
    EU_REGULATION_SECTION_MODULE_TITLE_1_3: "EU_REGULATION_SECTION_MODULE_TITLE_1_3",
    EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_1: "EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_1",
    EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_2: "EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_2",
    EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_3: "EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_3",
    EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_4: "EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_4",
    EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_5: "EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_5",
    EU_REGULATION_SECTION_MODULE_TITLE_2_1: "EU_REGULATION_SECTION_MODULE_TITLE_2_1",
    EU_REGULATION_SECTION_MODULE_TITLE_2_2: "EU_REGULATION_SECTION_MODULE_TITLE_2_2",
    EU_REGULATION_SECTION_MODULE_TITLE_2_3: "EU_REGULATION_SECTION_MODULE_TITLE_2_3",
    EU_REGULATION_SECTION_MODULE_DESCRIPTION_2_1: "EU_REGULATION_SECTION_MODULE_DESCRIPTION_2_1",

    /*** MISSION ***/
    /* MISSION - Main Title */
    MISSION_MAIN_TITLE_1: "MISSION_MAIN_TITLE_1",
    MISSION_MAIN_TITLE_2: "MISSION_MAIN_TITLE_2",
    MISSION_MAIN_TITLE_3: "MISSION_MAIN_TITLE_3",
    /* MiSSION - Blue & Cartel */
    //Title
    MISSION_CARTEL_TITLE: "MISSION_CARTEL_TITLE",
    MISSION_CARTEL_SUBTITLE: "MISSION_CARTEL_SUBTITLE",
    //Cartel
    MISSION_CARTEL_TITLE_1_1: "MISSION_CARTEL_TITLE_1_1",
    MISSION_CARTEL_TITLE_1_2: "MISSION_CARTEL_TITLE_1_2",
    MISSION_CARTEL_TITLE_1_3: "MISSION_CARTEL_TITLE_1_3",
    MISSION_CARTEL_DESCRIPTION_1: "MISSION_CARTEL_DESCRIPTION_1",
    MISSION_CARTEL_TITLE_2_1: "MISSION_CARTEL_TITLE_2_1",
    MISSION_CARTEL_TITLE_2_2: "MISSION_CARTEL_TITLE_2_2",
    MISSION_CARTEL_TITLE_2_3: "MISSION_CARTEL_TITLE_2_3",
    MISSION_CARTEL_TITLE_2_4: "MISSION_CARTEL_TITLE_2_4",
    MISSION_CARTEL_DESCRIPTION_2: "MISSION_CARTEL_DESCRIPTION_2",
    MISSION_CARTEL_TITLE_3_1: "MISSION_CARTEL_TITLE_3_1",
    MISSION_CARTEL_TITLE_3_2: "MISSION_CARTEL_TITLE_3_2",
    MISSION_CARTEL_TITLE_3_3: "MISSION_CARTEL_TITLE_3_3",
    MISSION_CARTEL_DESCRIPTION_3: "MISSION_CARTEL_DESCRIPTION_3",

    /*** SUPPORT ***/
    /* SUPPORT - Main Title */
    SUPPORT_MAIN_TITLE_1: "SUPPORT_MAIN_TITLE_1",
    SUPPORT_MAIN_TITLE_2: "SUPPORT_MAIN_TITLE_2",
    SUPPORT_MAIN_TITLE_3: "SUPPORT_MAIN_TITLE_3",
    SUPPORT_MAIN_TITLE_4: "SUPPORT_MAIN_TITLE_4",
    /* SUPPORT - Button */
    SUPPORT_MAIN_BUTTON_1: "SUPPORT_MAIN_BUTTON_1",
    SUPPORT_MAIN_BUTTON_2: "SUPPORT_MAIN_BUTTON_2",
    /* SUPPORT - Module */
    SUPPORT_MODULE_CARTEL_TITLE_1: "SUPPORT_MODULE_CARTEL_TITLE_1",
    SUPPORT_MODULE_CARTEL_DESCRIPTION_1: "SUPPORT_MODULE_CARTEL_DESCRIPTION_1",
    SUPPORT_MODULE_CARTEL_FOOTER_1_1: "SUPPORT_MODULE_CARTEL_FOOTER_1_1",
    SUPPORT_MODULE_CARTEL_FOOTER_1_2: "SUPPORT_MODULE_CARTEL_FOOTER_1_2",
    SUPPORT_MODULE_CARTEL_TITLE_2: "SUPPORT_MODULE_CARTEL_TITLE_2",
    SUPPORT_MODULE_CARTEL_DESCRIPTION_2: "SUPPORT_MODULE_CARTEL_DESCRIPTION_2",
    SUPPORT_MODULE_CARTEL_FOOTER_2_1: "SUPPORT_MODULE_CARTEL_FOOTER_2_1",
    SUPPORT_MODULE_CARTEL_FOOTER_2_2: "SUPPORT_MODULE_CARTEL_FOOTER_2_2",
    SUPPORT_MODULE_CARTEL_TITLE_3: "SUPPORT_MODULE_CARTEL_TITLE_3",
    SUPPORT_MODULE_CARTEL_DESCRIPTION_3: "SUPPORT_MODULE_CARTEL_DESCRIPTION_3",
    SUPPORT_MODULE_CARTEL_FOOTER_3_1: "SUPPORT_MODULE_CARTEL_FOOTER_3_1",
    SUPPORT_MODULE_CARTEL_FOOTER_3_2: "SUPPORT_MODULE_CARTEL_FOOTER_3_2",
    /* SUPPORT - Rules */
    SUPPORT_RULES_TITLE_1: "SUPPORT_RULES_TITLE_1",
    SUPPORT_RULES_1_1: "SUPPORT_RULES_1_1",
    SUPPORT_RULES_1_2: "SUPPORT_RULES_1_2",
    SUPPORT_RULES_1_3: "SUPPORT_RULES_1_3",
    SUPPORT_RULES_1_4: "SUPPORT_RULES_1_4",
    SUPPORT_RULES_1_5: "SUPPORT_RULES_1_5",
    SUPPORT_RULES_1_6: "SUPPORT_RULES_1_6",
    SUPPORT_RULES_TITLE_2: "SUPPORT_RULES_TITLE_2",
    SUPPORT_RULES_2_1: "SUPPORT_RULES_2_1",
    SUPPORT_RULES_2_2: "SUPPORT_RULES_2_2",
    SUPPORT_RULES_2_3: "SUPPORT_RULES_2_3",
    SUPPORT_RULES_2_4: "SUPPORT_RULES_2_4",
    SUPPORT_RULES_2_5: "SUPPORT_RULES_2_5",
    SUPPORT_RULES_2_6: "SUPPORT_RULES_2_6",
    SUPPORT_RULES_2_7: "SUPPORT_RULES_2_7",

    /*** PRIVACY POLICY ***/
    PRIVACY_POLICY_TITLE: "PRIVACY_POLICY_TITLE",
    PRIVACY_POLICY_TITLE_1: "PRIVACY_POLICY_TITLE_1",
    PRIVACY_POLICY_DESCRIPTION_1: "PRIVACY_POLICY_DESCRIPTION_1",
    PRIVACY_POLICY_TITLE_2: "PRIVACY_POLICY_TITLE_2",
    PRIVACY_POLICY_DESCRIPTION_2: "PRIVACY_POLICY_DESCRIPTION_2",
    PRIVACY_POLICY_TITLE_3: "PRIVACY_POLICY_TITLE_3",
    PRIVACY_POLICY_DESCRIPTION_3: "PRIVACY_POLICY_DESCRIPTION_3",
    PRIVACY_POLICY_TITLE_4: "PRIVACY_POLICY_TITLE_4",
    PRIVACY_POLICY_DESCRIPTION_4: "PRIVACY_POLICY_DESCRIPTION_4",

    /*** APP PERMISSIONS ***/
    APP_PERMISSIONS_TITLE: "APP_PERMISSIONS_TITLE",

    /*** Confidentiality Agreement ***/
    CONFIDENTIALITY_AGREEMENT_TITLE: "CONFIDENTIALITY_AGREEMENT_TITLE",
    CONFIDENTIALITY_AGREEMENT_TITLE_1: "CONFIDENTIALITY_AGREEMENT_TITLE_1",
    CONFIDENTIALITY_AGREEMENT_DESCRIPTION_1: "CONFIDENTIALITY_AGREEMENT_DESCRIPTION_1",
    CONFIDENTIALITY_AGREEMENT_TITLE_2: "CONFIDENTIALITY_AGREEMENT_TITLE_2",
    CONFIDENTIALITY_AGREEMENT_DESCRIPTION_2: "CONFIDENTIALITY_AGREEMENT_DESCRIPTION_2",
    CONFIDENTIALITY_AGREEMENT_TITLE_3: "CONFIDENTIALITY_AGREEMENT_TITLE_3",
    CONFIDENTIALITY_AGREEMENT_DESCRIPTION_3: "CONFIDENTIALITY_AGREEMENT_DESCRIPTION_3",
    CONFIDENTIALITY_AGREEMENT_TITLE_4: "CONFIDENTIALITY_AGREEMENT_TITLE_4",
    CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4: "CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4",
    CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4_1: "CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4_1",
    CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4_2: "CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4_2",
    CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4_3: "CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4_3",
    CONFIDENTIALITY_AGREEMENT_TITLE_5: "CONFIDENTIALITY_AGREEMENT_TITLE_5",
    CONFIDENTIALITY_AGREEMENT_DESCRIPTION_5: "CONFIDENTIALITY_AGREEMENT_DESCRIPTION_5",
    CONFIDENTIALITY_AGREEMENT_TITLE_6: "CONFIDENTIALITY_AGREEMENT_TITLE_6",
    CONFIDENTIALITY_AGREEMENT_DESCRIPTION_6: "CONFIDENTIALITY_AGREEMENT_DESCRIPTION_6",
    CONFIDENTIALITY_AGREEMENT_TITLE_7: "CONFIDENTIALITY_AGREEMENT_TITLE_7",
    CONFIDENTIALITY_AGREEMENT_DESCRIPTION_7: "CONFIDENTIALITY_AGREEMENT_DESCRIPTION_7",

    /*** Term Of Use ***/
    TERM_OF_USE_TITLE: "TERM_OF_USE_TITLE",
    TERM_OF_USE_TITLE_1: "TERM_OF_USE_TITLE_1",
    TERM_OF_USE_DESCRIPTION_1: "TERM_OF_USE_DESCRIPTION_1",
    TERM_OF_USE_TITLE_2: "TERM_OF_USE_TITLE_2",
    TERM_OF_USE_DESCRIPTION_2: "TERM_OF_USE_DESCRIPTION_2",
    TERM_OF_USE_TITLE_3: "TERM_OF_USE_TITLE_3",
    TERM_OF_USE_DESCRIPTION_3: "TERM_OF_USE_DESCRIPTION_3",
    TERM_OF_USE_TITLE_4: "TERM_OF_USE_TITLE_4",
    TERM_OF_USE_DESCRIPTION_4_1: "TERM_OF_USE_DESCRIPTION_4_1",
    TERM_OF_USE_DESCRIPTION_4_2: "TERM_OF_USE_DESCRIPTION_4_2",
    TERM_OF_USE_DESCRIPTION_4_3: "TERM_OF_USE_DESCRIPTION_4_3",
    TERM_OF_USE_TITLE_5: 'TERM_OF_USE_TITLE_5',
    TERM_OF_USE_DESCRIPTION_5_1: 'TERM_OF_USE_DESCRIPTION_5_1',
    TERM_OF_USE_DESCRIPTION_5_2: 'TERM_OF_USE_DESCRIPTION_5_2',
    TERM_OF_USE_TITLE_6: "TERM_OF_USE_TITLE_6",
    TERM_OF_USE_DESCRIPTION_6: "TERM_OF_USE_DESCRIPTION_6",
    TERM_OF_USE_TITLE_7: "TERM_OF_USE_TITLE_7",
    TERM_OF_USE_DESCRIPTION_7: "TERM_OF_USE_DESCRIPTION_7",
    TERM_OF_USE_TITLE_8: "TERM_OF_USE_TITLE_8",
    TERM_OF_USE_DESCRIPTION_8: "TERM_OF_USE_DESCRIPTION_8",

    /*** DONATE FORM ***/
    DONATE_FORM_TITLE: "DONATE_FORM_TITLE",
    //DONATE FORM - Form
    DONATE_FORM_FORM_TITLE: "DONATE_FORM_FORM_TITLE",
    DONATE_FORM_INPUT_LABEL_NAME: "DONATE_FORM_INPUT_LABEL_NAME",
    DONATE_FORM_INPUT_PLACEHOLDER_NAME: "DONATE_FORM_INPUT_PLACEHOLDER_NAME",
    DONATE_FORM_INPUT_LABEL_EMAIL: "DONATE_FORM_INPUT_LABEL_EMAIL",
    DONATE_FORM_INPUT_PLACEHOLDER_EMAIL: "DONATE_FORM_INPUT_PLACEHOLDER_EMAIL",
    DONATE_FORM_INPUT_LABEL_PHONE: "DONATE_FORM_INPUT_LABEL_PHONE",
    DONATE_FORM_INPUT_PLACEHOLDER_PHONE: "DONATE_FORM_INPUT_PLACEHOLDER_PHONE",
    DONATE_FORM_ONPUT_LABEL_FIND_US: "DONATE_FORM_ONPUT_LABEL_FIND_US",
    DONATE_FORM_ONPUT_SELECT_FIND_US_1: "DONATE_FORM_ONPUT_SELECT_FIND_US_1",
    DONATE_FORM_ONPUT_SELECT_FIND_US_2: "DONATE_FORM_ONPUT_SELECT_FIND_US_2",
    DONATE_FORM_ONPUT_SELECT_FIND_US_3: "DONATE_FORM_ONPUT_SELECT_FIND_US_3",
    DONATE_FORM_ONPUT_SELECT_FIND_US_4: "DONATE_FORM_ONPUT_SELECT_FIND_US_4",
    DONATE_FORM_ONPUT_SELECT_FIND_US_5: "DONATE_FORM_ONPUT_SELECT_FIND_US_5",
    DONATE_FORM_ONPUT_PLEDGE_AMOUNT: "DONATE_FORM_ONPUT_PLEDGE_AMOUNT",
    DONATE_FORM_ONPUT_OTHER_AMOUNT: "DONATE_FORM_ONPUT_OTHER_AMOUNT",
    DONATE_FORM_INPUT_LABEL_MESSAGE: "DONATE_FORM_INPUT_LABEL_MESSAGE",
    DONATE_FORM_INPUT_PLACEHOLDER_MESSAGE: "DONATE_FORM_INPUT_PLACEHOLDER_MESSAGE",
    DONATE_FORM_INPUT_LABEL_CREDIT_CARD: "DONATE_FORM_INPUT_LABEL_CREDIT_CARD",
    DONATE_FORM_INPUT_PLACEHOLDER_CREADIT_CARD: "DONATE_FORM_INPUT_PLACEHOLDER_CREADIT_CARD",
    DONATE_FORM_INPUT_TERM_OF_USE: "DONATE_FORM_INPUT_TERM_OF_USE",
    //DONATE FORM - Validation
    DONATE_FORM_VALIDATION_TITLE_1: "DONATE_FORM_VALIDATION_TITLE_1",
    DONATE_FORM_VALIDATION_TITLE_2: "DONATE_FORM_VALIDATION_TITLE_2",
    DONATE_FORM_VALIDATION_DESCRIPTION_1: "DONATE_FORM_VALIDATION_DESCRIPTION_1",
    DONATE_FORM_VALIDATION_DESCRIPTION_2: "DONATE_FORM_VALIDATION_DESCRIPTION_2",
    DONATE_FORM_VALIDATION_DESCRIPTION_3: "DONATE_FORM_VALIDATION_DESCRIPTION_3",
}